/** @jsx dom */
'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
exports.render = render;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

function render(_ref) {
	var props = _ref.props;
	var center = props.center;
	var children = props.children;

	function getClasses() {
		var classes = {
			'Grid-cell': true,
			'Grid-cell--center': Boolean(center)
		};

		['size', 'xsm-size', 'sm-size', 'md-size', 'lg-size', 'xlg-size'].forEach(function (el) {
			classes['u-' + el + props[el]] = /^\d+of\d+$/.test(props[el]);
			classes['u-' + el + 'Fit'] = props[el] === 'fit';
			classes['u-' + el + 'FitAlt'] = props[el] === 'fit-alt';
			classes['u-' + el + 'Fill'] = props[el] === 'fill';
			classes['u-' + el + 'FillAlt'] = props[el] === 'fill-alt';
			classes['u-' + el + 'Full'] = props[el] === 'full';
		});

		return classes;
	}

	return (0, _magicVirtualElement2['default'])(
		'div',
		{ 'class': [getClasses(), props['class']] },
		children
	);
}